import React from "react"
import Select from "react-select"
import Text from "components/text"
import "./index.scss"

const FormMobile = ({
  name,
  value,
  handleChange,
  error,
  handleChangeCountry,
  options,
  country_code,
  horizontal,
  label,
  required,
}) => {
  let hasError = Boolean(error)
  return (
    <div className={`form-input ${horizontal ? "-horizontal" : "-vertical"}`}>
      <Text type="label" text={label + (required ? " *" : "")} />
      <div className="columns-mobile">
        <div className="column">
          <Select
            value={country_code}
            onChange={handleChangeCountry}
            options={options}
            className="mobile-select"
          />
        </div>
        <div className="column">
          <input
            type="text"
            className="mobile-input"
            name={name}
            value={value || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      {hasError && <p className="error-message">{`* ${error}`}</p>}
    </div>
  )
}

export default FormMobile
